import React from 'react'
import { BiCode } from 'react-icons/bi'
import { BsDatabase, BsHeadphones } from 'react-icons/bs'
import { CiSettings } from 'react-icons/ci'
import { FaGraduationCap, FaUserSecret } from 'react-icons/fa'

const ServerSection = ({   
  features = [],

 }) => {
  return (
    <div>
         <section className="bg-slate-50 py-20">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-slate-900 mb-4">
            Unmatched <span className="text-cyan-500">digital innovation</span> and{" "}
            <span className="text-cyan-500">talent partnership services</span>
          </h2>
        </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {features.map((feature, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-md transition-shadow"
        >
          <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-6">
            <feature.icon className="w-6 h-6 text-blue-600" />
          </div>
          <h3 className="text-xl font-semibold text-slate-900 mb-4">
            {feature.title}
          </h3>
          <p className="text-slate-600 text-sm leading-relaxed">
            {feature.description}
          </p>
        </div>
      ))}
    </div>
      </div>
    </section>
    </div>
  )
}

export default ServerSection